import { GAME_ID, REDUX_ACTIONS } from '../../data/constants';

export const initialState = {
  windowLayout: {},
  feedbackIsVisible: false,
  highlightedPicture: null,
  interactionLocked: false,
  placeholderHighlighted: false,
};

const uxReducer = (state = initialState, { type, payload, gameId }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case REDUX_ACTIONS.SET_FEEDBACK_VISIBLE:
      return {
        ...state,
        feedbackIsVisible: payload.feedbackIsVisible,
      };

    case REDUX_ACTIONS.SET_HIGHLIGHTED_PICTURE:
      return {
        ...state,
        highlightedPicture: payload.highlightedPicture,
      };
    case REDUX_ACTIONS.SET_INTERACTION_LOCKED:
      return {
        ...state,
        interactionLocked: payload.interactionLocked,
      };
    case REDUX_ACTIONS.INIT_DRAG_AND_DROP:
      return {
        ...state,
        placeholderHighlighted: false,
      };
    case REDUX_ACTIONS.SET_WINDOW_LAYOUT:
      return {
        ...state,
        windowLayout: payload.windowLayout,
      };
    case REDUX_ACTIONS.SET_PLACEHOLDER_HIGHLIGHTED:
      return {
        ...state,
        placeholderHighlighted: payload.placeholderHighlighted,
      };
    default:
      return state;
  }
};

export default uxReducer;
